<script setup>
import Duration from '@common/Duration'
import { Line } from 'vue-chartjs'

const { DateTime } = require('luxon')
import { ref, reactive , watch} from 'vue'


import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
)

//const data = reactive([])
const selectedDuration = ref('LAST_30_DAYS');

const props = defineProps({
  entity: {
    type: Object,
    required: true,
  },
  store : {
    type: Object,
    default : {}
  }
})

const chartOptions = {
  scales : {
    y :
      {
        beginAtZero : true,
    },

  }
}

const chartData = reactive({
  labels: [],
  datasets: [
    {
      label: 'Officiële Prijs',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [],
    },
    {
      label: 'Lokale Prijs',
      backgroundColor: 'rgba(5,166,166,0.2)',
      borderColor: 'rgba(5,166,166,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(5,166,166,0.4)',
      hoverBorderColor: 'rgba(5,166,166,1)',
      data: [],

    },
  ],
})

let lastFoundIndex = 0;

watch(() => props.store, (newValue, oldValue) => fetchDataForDuration(selectedDuration.value))


const fetchDataForDuration = (duration) => {
  selectedDuration.value = duration,
  chartData.datasets.forEach((dataset)=>dataset.data = []);
  chartData.labels = [];
  lastFoundIndex = 0;
  axios
    .get(
      route('api.products.pricehistory', {
        product: props.entity.id,
        duration: duration,
        storeId: props.store.id
      })
    )
    .then((response) => {
      console.log(response.data);
      processData(response.data ,duration);
    })
    .catch((error) => {
      console.error(error)
    })
}

/* creates labels for every day for the chosen duration.
* the fetches the corresponding price for each day.
*
* values are stored in the chartData object.
* */

const processData = (responseData , duration) => {

  let timeInterval = 0;
  switch (duration) {
    case 'CURRENT_YEAR':
      timeInterval = 365;
      break;
    case 'LAST_90_DAYS':
      timeInterval = 91;
      break;
    default:
      timeInterval = 31;
  }
  let today = new Date();
  let dataSet1 = responseData.officialPriceHistory;
  let dataSet2 = responseData.localPriceHistory;
  let dataSets = [dataSet1,dataSet2];


// creating chartData.labels
  for (let i = 0; i < timeInterval; i++) {
    let day = new Date();
    day.setDate(today.getDate() - i);
    chartData.labels.unshift(day.toLocaleDateString());
  }

  // fill out the datasets
  dataSets.forEach((dataSet , index )=>{
    lastFoundIndex = 0;
    if(dataSet.length){
      chartData.datasets[index].data = chartData.labels.map(( date ) => {
        return {
          x : date,
          y : findValue(date , dataSet)
        }
      })
    }
  })
}

/*
* Search for the date in the dataset and return the price.
* If there is no entry for the day the de last found price is returned.
* */

const findValue = function ( date , dataSet ) {

  let index = dataSet.findIndex((el)=> date === formattedDate(el.created_at));

  if(index >= 0){ lastFoundIndex = index }
  return (index >-1)? dataSet[index].price : dataSet[lastFoundIndex].price;
}

const formattedDate = function (date){
  return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
}

</script>

<template>
  <div class="mt-16 w-full space-y-4 px-4">
    <Duration @update-selected="fetchDataForDuration" />
    <Line :chart-data="chartData" :chartOptions="chartOptions" :height="100" class="mt-4"></Line>
  </div>
</template>
